import styled from 'styled-components';

export const Headerstyles = styled.div`
  position: relative;
  width: 100%;
  background-color: #4a148c;
  overflow: hidden;

  .title-wrap {
    width: 300px;
    position: absolute;
    top: 20px;
    right: 20px;

    @media (max-width: 500px) {
      width: 200px;
    }

    .title {
      color: #ffe040;
      font-size: 42px;
      line-height: 1.1;
      font-weight: 500;
      text-align: right;
      font-style: normal;
      font-stretch: condensed;
      font-family: 'SBS Sans', sans-serif;
      text-transform: uppercase;

      @media (max-width: 400px) {
        font-size: 32px;
      }
    }
  }

  .world-cup-logo {
    position: relative;
    width: 200px;
    height: auto;
    padding: 30px 20px;
  }

  nav {
    display: flex;
    flex-wrap: nowrap;
    gap: 4px;
    margin-left: 20px;
    padding: 0 20px 12px;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
    scroll-padding-inline: 20px;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  button {
    flex: 0 0 auto;
    background-color: transparent;
    color: #fff;
    border: 2px solid #fff;
    border-radius: 20px;
    padding: 6px 16px;
    margin: 2px 0;
    white-space: nowrap;
    cursor: pointer;
    font-size: 18px;
    font-weight: 500;
    font-style: normal;
    font-stretch: condensed;
    font-family: 'SBS Sans', sans-serif;
    transition:
      background-color 0.3s,
      color 0.3s;

    &.active,
    &:active {
      background-color: #fff;
      color: #4a148c;
    }
  }

  @media (max-width: 767px) {
    .world-cup-logo {
      width: 160px;
      padding: 24px 16px 20px;
    }

    nav {
      margin-left: 0;
      padding: 0 16px 12px;
      scroll-padding-inline: 16px;
    }

    button {
      font-size: 16px;
      padding: 6px 14px;
    }
  }
`;
